import {BaseEvent} from "./BaseEvent";

export class MarkupPointEvent extends BaseEvent {
  static POSITION_CHANGED = 'markupPointPositionChanged';
  static VISIBILITY_CHANGED = 'markupPointVisibilityChanged';
}